module.exports = __webpack_public_path__ + "img/2-low.6ab60a1a.jpg";